import { useTranslation } from "react-i18next";
import useGetExercise from "../../api/useGetExercise";
import ExercisePreview from "../../components/ExercisePreview";
import { useParams, Link } from "react-router-dom";
import { Button, Box } from "@material-ui/core";
import { ArrowBack, ArrowForward } from "@material-ui/icons";

export const ViewExercise: React.VFC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const exerciseId = parseInt(id, 10);
  const { data: exercise, isLoading, error } = useGetExercise(exerciseId);

  return (
    <div>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button
          component={Link}
          to={`/create-content/exercises/${exerciseId - 1}`}
          disabled={exerciseId <= 1}
          startIcon={<ArrowBack />}
        >
          {t("view_exercise.previous")}
        </Button>
        <Box>{t("view_exercise.id_label", { exerciseId })}</Box>
        <Button component={Link} to={`/create-content/exercises/${exerciseId + 1}`} endIcon={<ArrowForward />}>
          {t("view_exercise.next")}
        </Button>
      </Box>
      {isLoading && <div>{t("view_exercise.loading")}</div>}
      {error && <div>{t("view_exercise.error_loading")}</div>}
      {exercise && <ExercisePreview exercise={exercise} />}
    </div>
  );
};
